module.exports = __webpack_public_path__ + "img/0737ce8.png";